import { render, staticRenderFns } from "./page404.vue?vue&type=template&id=23ce8224&"
import script from "./page404.vue?vue&type=script&lang=js&"
export * from "./page404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports